import { createSlice } from '@reduxjs/toolkit';
import axiosInstance from 'src/utils/axiosInstance';

const TOKEN_STORAGE_KEY = 'loginToken';
const USER_DATA = 'user-data';

const initialState = {
  token: localStorage.getItem(TOKEN_STORAGE_KEY),
};

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    loginSuccess: (state, action) => {
      state.token = action.payload.token;
      localStorage.setItem(TOKEN_STORAGE_KEY, action.payload.token);
      localStorage.setItem(USER_DATA, JSON.stringify(action.payload));
    },
    logout: (state) => {
      state.token = null;
      localStorage.removeItem(TOKEN_STORAGE_KEY);
    },
  },
});

export const { loginSuccess, logout } = authSlice.actions;

export const login = (body) => async (dispatch) => {
  try {
    const response = await axiosInstance.post('/auth/admin-signin', {
      email: body.email,
      password: body.password,
      remember: body.remember !== undefined ? body.remember : true,
    });

    if (response.data && response.data.status === true) {
      const userData = response.data.data;
      dispatch(loginSuccess(userData));
      return { status: true, message: response.data.message, data: userData };
    } else {
      return { status: false, message: response.data?.message || 'Login failed' };
    }
  } catch (error) {
    const errorMsg = error.response?.data?.message || error.message || 'Login failed';
    return { status: false, message: errorMsg };
  }
};

export const logoutUser = () => async (dispatch) => {
  try {
    await dispatch(logout());
    localStorage.clear();
  } catch (err) {
    throw new Error(err);
  }
};

export default authSlice.reducer;
